<div
  class="tooltip"
  role="tooltip">
  {{ tooltip | optionalAsync }}
</div>
